import React from 'react'
import { Link } from 'react-router-dom'
import { AppContainer, Header, Navigation } from '@templatean/shared/components'
import { useAuth } from '@templatean/shared/hooks'

const App: React.FC = () => {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <AppContainer>
        <div className="loading-container">
          <div className="loading-spinner" />
          <p>Loading Templatean for Outlook...</p>
        </div>
      </AppContainer>
    )
  }

  if (!user) {
    return (
      <AppContainer>
        <div className="auth-prompt">
          <h2>Welcome to Templatean for Outlook</h2>
          <p>Please sign in through the Templatean web app to continue.</p>
          <a href="https://app.templatean.com/login" target="_blank" className="btn btn-primary">
            Sign In
          </a>
        </div>
      </AppContainer>
    )
  }

  const navItems = [
    { id: 'agent', label: 'AI Agent', icon: '🤖' },
    { id: 'email-templates', label: 'Email Templates', icon: '📧' },
    { id: 'email-composer', label: 'AI Composer', icon: '✨' },
    { id: 'email-tracker', label: 'Email Tracker', icon: '📊' },
    { id: 'settings', label: 'Settings', icon: '⚙️' },
  ]

  return (
    <AppContainer>
      <Header 
        title="Templatean for Outlook"
        subtitle={`Welcome, ${user.fullName}`}
      />
      
      <Navigation items={navItems} />
      
      <div className="home-content">
        <section className="feature-grid">
          <Link to="/agent" className="feature-card feature-card-primary">
            <div className="feature-icon">🤖</div>
            <h3>AI Agent</h3>
            <p>Chat with AI assistants to compose, improve, and manage your emails</p>
          </Link>

          <Link to="/email-templates" className="feature-card">
            <div className="feature-icon">📧</div>
            <h3>Email Templates</h3>
            <p>Access professional email templates for various business scenarios</p>
          </Link>

          <Link to="/email-composer" className="feature-card">
            <div className="feature-icon">✨</div>
            <h3>AI Email Composer</h3>
            <p>Generate personalized emails with AI assistance</p>
          </Link>

          <Link to="/email-tracker" className="feature-card">
            <div className="feature-icon">📊</div>
            <h3>Email Tracker</h3>
            <p>Track email opens, clicks, and engagement analytics</p>
          </Link>
        </section>
        
        <section className="quick-tips">
          <h3>Quick Tips</h3>
          <ul>
            <li>Use templates to maintain consistent communication</li>
            <li>Let AI help you write more effective emails</li>
            <li>Track engagement to optimize your outreach</li>
            <li>Customize templates with your brand voice</li>
          </ul>
        </section>
      </div>
    </AppContainer>
  )
}

export default App